export default {
    'name': 'legalStatus',
    'label': 'legal.tabs.LegalStatus',
    'getComponent': () => import('./legal-status.vue'),
    'tabIndex': 6,
    'left': true,
    'right': true,
    'singleView': true,
    'exclusiveRoutePath': '/legal/status',
    'aclCheckKey': 'legal',
};
